export default {"src":"/_next/static/media/arrowDown.6f7b9e7b.svg","height":9,"width":9,"blurWidth":0,"blurHeight":0};